// extracted by mini-css-extract-plugin
export var text = "_m-0";